export default function makeUtcDate(year: number, month?: number, day?: number): Date {
    month = undefined === month ? 1 : month;
    day = undefined === day ? 1 : day;
    const monthOffset = 0 === day ? 1 : 0;
    return new Date(Date.UTC(year, month - 1 + monthOffset, day));
}
